// hello! getStates, stateNamesToCodes, stateNamesToIds
// should be replaced with useMetadata()
export const getStates = async (axios, store) => {
  if (store.getters.addressStateData.length === 0) {
    const stateData = (await axios.get('/api/address/state/')).data.results
    store.dispatch('setAddressStateData', stateData)
  }
  return store.getters.addressStateData
}
export const stateNamesToCodes = (states) => {
  const stateNamesToCodes = {}
  states.forEach((state) => {
    stateNamesToCodes[state.name] = state.usps_code
  })
  return stateNamesToCodes
}
export const stateNamesToIds = (states) => {
  const stateNamesToIds = {}
  states.forEach((state) => {
    stateNamesToIds[state.name] = state.id
  })
  return stateNamesToIds
}

export const getAddresses = async ($axios, page) => {
  try {
    return await $axios.get('/api/address/user-address/', { params: { page } })
  } catch (e) {
    console.error('Failed fetching addresses', e)
    throw e
  }
}

export const getAddress = async ($axios, addressId) => {
  try {
    return await $axios.get(`/api/address/user-address/${addressId}/`)
  } catch (e) {
    console.error('Failed fetching addresses', e)
    throw e
  }
}

export const updateAddress = async ($axios, addressId, data) => {
  try {
    return await $axios.patch(`/api/address/user-address/${addressId}/`, data)
  } catch (e) {
    console.error(`Failed updating addressId: ${addressId}`, e)
    throw e
  }
}

export const updateDefaultAddress = async ($axios, addressId) => {
  try {
    return await $axios.post(`/api/address/default-user-address/${addressId}/`)
  } catch (e) {
    console.error(
      `Failed updating default address to address id: ${addressId}`,
      e,
    )
    throw e
  }
}

export const addAddress = async ($axios, data) => {
  try {
    return await $axios.post('/api/address/user-address/', data)
  } catch (e) {
    console.error('Failed adding address', e)
    throw e
  }
}

export const deleteAddress = async ($axios, addressId) => {
  try {
    return await $axios.delete(`/api/address/user-address/${addressId}/`)
  } catch (e) {
    console.error(`Failed deleting address id: ${addressId}`, e)
    throw e
  }
}
